const types = require('constants/actionTypes');

const closed = () => ({ type: types.GLOSSARY_CLOSED });

module.exports = closed;
